import { Controller } from '@hotwired/stimulus';

// Update rules without replacing the automation controller or its playback state.
export default class extends Controller {
  static values = { rules: Array };

  rulesValueChanged() {
    this.dispatch('changed', { detail: { rules: this.rulesValue } });
  }
}
